import styled, { css, keyframes } from 'styled-components'

const showData = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

export const ContentWrapper = styled.div`
  h3 {
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 24px;
  }

  .content {
    overflow-y: auto;
    /* height: calc(110px + (600 — 110) * ((70vh — 210px) / (1080 — 110))); */
  }

  p.title {
    margin-bottom: 8px;
    font-weight: 600;
  }

  @media (max-height: 630px) {
    max-height: 95%;

    .content {
      overflow-y: auto;
      height: 40vh;
    }
  }
`

export const HeaderModalClose = styled.button`
  background: none;
  border: 0;
  position: absolute;
  top: 38px;
  right: 32px;
  transition: all 400ms;
  cursor: pointer;

  img {
    width: 18px;
  }

  &:hover {
    opacity: 0.6;
  }
`

export const Main = styled.main`
  display: flex;
  flex-direction: column;
  height: 100vh;
`

export const Profile = styled.section`
  background-color: rgb(251, 251, 251);
  padding: 32px 0;
  flex: 1;
`

export const ProfileTitle = styled.h2`
  font-size: 22px;
  color: #555;
`

export const PageContent = styled.div``

export const Wrapper = styled.div`
  max-width: 1360px;
  margin: 0 auto;
  position: relative;
  width: 100%;

  @media (max-width: 1390px) {
    max-width: 95%;
  }
`
export const ColGroup = styled.div`
  max-width: 1360px;
  display: flex;
  /* justify-content: center; */
  align-items: flex-start;

  @media (max-width: 1170px) {
    .col-3 {
      display: none;
    }

    .col-9 {
      width: 100%;
    }
  }
`
export const ProfileContent = styled.div`
  .content-vendas {
    transition: all ease-in-out 400ms;
    animation: ${showData} 400ms;
  }

  .promotor-data {
    transition: all ease-in-out 400ms;
    animation: ${showData} 1s;
  }

  @media (max-width: 800px) {
    .voltar {
      width: 100%;
    }
  }
`
export const HeaderCotacaoNegociacao = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 8px;
`

export const Fichas = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  gap: 16px;
`

export const ProfileMenu = styled.nav`
  margin-right: 15%;
`

export const ProfileBox = styled.div`
  background: #ffffff;
  padding: 30px 30px 30px 30px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
`

export const ProfileBoxFooter = styled.div`
  margin: 10px 0 20px 0;
`

export const ButtonAddNewAddress = styled.button`
  ${({ theme }) => css`
    border-radius: 4px;
    border: 2px solid transparent;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
    padding: 15px 30px;
    text-align: center;
    transition: ${theme.transition.default};
    cursor: pointer;
    background: ${theme.colors.primary};
    color: ${theme.colors.white};

    &:hover {
      background: #a71e26;
    }

    & + .button {
      margin-left: 15px;
    }

    @media (max-width: ${theme.media.ipad}) {
      font-size: 14px;
    }
  `}
`

export const ButtonVoltar = styled.button`
  ${({ theme }) => css`
    padding: 12px 16px;
    border-radius: 4px;

    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    background: #27ae60;
    border: 2px solid #27ae60;
    color: #fff;

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all ease-in-out 400ms;

    &:hover {
      background: #33a161;
    }

    img {
      margin-right: 12px;
    }

    &.outline-green {
      background: transparent;
      color: #27ae60;
      border: 2px solid #27ae60;
    }

    &.outline {
      background: transparent;
      color: #707070;
      border: 2px solid #707070;
      height: 36px;
    }

    @media (max-width: 800px) {
      width: 100%;

      &.outline {
        width: 100%;
      }
    }
  `}
`
